import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { desktopMenu, navbar } from "../data/data";
import Logo from "./Logo";
import { BiMenuAltLeft } from "react-icons/bi";
import { CgClose } from "react-icons/cg";
import CookieNotice from "../pages/components/CookieNotice";
import { useCookies } from "react-cookie";
// import CookieConsent from "react-cookie-consent"

export default function Header() {
  const [links] = useState(navbar);
  const [menu] = useState(desktopMenu);
  const [isOpen, setIsOpen] = useState(false);
  const [cookies, setCookie] = useCookies(["privacy"]);

  const applyCookies = () => {
    setCookie("privacy", { path: "/" });
  };

  const handleClick = (value) => {
    const navbar = document.querySelector(".navbar");
    const listItems = document.querySelectorAll(".list-items");

    navbar.classList.toggle("open");
    listItems.forEach((item) =>
      item.addEventListener("click", value, () =>
        navbar.classList.remove("open")
      )
    );
  };

  return (
    <>
      <div>
        {/* <CookieConsent
          location="bottom"
          buttonText="Accept All Cookies"
          cookieName="BeBrokers"
          style={{ backgroundColor: "#4970bf" }}
          buttonStyle={{
            color: "#ffffff",
            backgroundColor: "#f58b23",
            fontSize: "16px",
          }}
          expires={150}
          enableDeclineButton
          declineButtonStyle={{ backgroundColor: "#ffffff", color: "#111827" }}
          onDecline={() => console.log("User did not accept cookies")}
        >
          This website uses cookies to enhance user experience.
        </CookieConsent> */}
        {!("privacy" in cookies) && (
          <CookieNotice setOpenCookies={applyCookies} />
        )}
      </div>

      <header className="bg-blue shadow-md">
        <div className="header p-5 relative flex justify-between xl:max-w-6xl xl:mx-auto 2xl:px-0 lg:flex-col">
          <div className="flex items-center justify-between">
            <Logo />

            <nav className="navbar absolute top-20 text-right text-white p-5 w-full lg:top-0 lg:w-auto lg:relative lg:p-0 lg:flex lg:items-center">
              <ul className="lg:flex items-center justify-center">
                {links.map(({ id, title, url }) => (
                  <li key={id} className="list-items mb-8 lg:mb-0 lg:mx-5">
                    <Link to={url} className="uppercase">
                      {title}
                    </Link>
                  </li>
                ))}
              </ul>

              {/* Desktop menu button */}
              <div className="hidden lg:block">
                <button onClick={() => setIsOpen(!isOpen)}>
                  {isOpen ? (
                    <CgClose className="text-white text-5xl" />
                  ) : (
                    <BiMenuAltLeft className="text-white text-5xl" />
                  )}
                </button>
              </div>
            </nav>
          </div>

          <div className="lg:hidden">
            <button onClick={handleClick}>
              <BiMenuAltLeft className="text-white text-4xl" />
            </button>
          </div>
        </div>

        {/* Desktop Menu */}
        {isOpen && (
          <div
            className={`bg-blue px-5 2xl:px-5 jumbotron ${isOpen && "open"}`}
          >
            <nav className="hidden lg:block rounded">
              <div className="grid grid-cols-4 lg:gap-5 xl:grid-cols-5 xl:gap-10 place-items-center items-start xl:max-w-6xl xl:mx-auto pt-5">
                {menu.map(({ id, title, url, items }) => (
                  <ul key={id}>
                    <li onClick={() => setIsOpen(false)}>
                      <Link
                        to={url}
                        className="text-white font-bold text-2xl mb-3 block"
                      >
                        {title}
                      </Link>
                    </li>

                    <ul>
                      {items.map((item, index) => (
                        <li
                          key={index}
                          onClick={() => setIsOpen(false)}
                          className="text-white my-6"
                        >
                          <Link to={url} className="block">
                            {item}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </ul>
                ))}
              </div>
            </nav>
          </div>
        )}
      </header>
    </>
  );
}
